import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './scss/global.scss'
// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app"
// import * as firestore from "firebase/firestore"
// import { getAnalytics } from "firebase/analytics"
// import {getFirestore} from 'firebase/firestore'

// const firebaseConfig = {
//     apiKey: "AIzaSyCwiLtavCYfMmQabbwkU10QEMEmEqFpH3A",
//     authDomain: "vcards-wist.firebaseapp.com",
//     projectId: "vcards-wist",
//     storageBucket: "vcards-wist.appspot.com",
//     messagingSenderId: "395777683733",
//     appId: "1:395777683733:web:7d1636ac0e46706049391c",
//     measurementId: "G-GKHMW2NNKS"
// };

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const db = getFirestore(app)

createApp(App)
    .use(store)
    .use(router)
    // .provide('$firestore', firestore)
    // .provide('$analytics', analytics)
    // .provide('$db', db)
    .mount('#app')
